import dayjs from "dayjs";

// Backend hands us startTime/endTime as ISO 8601 since KIN-2174 — keep one
// shared parser so date/time/duration stay consistent everywhere an
// appointment is rendered (table row, hover card, etc). No format argument:
// without dayjs's customParseFormat plugin it was ignored anyway, and with the
// plugin "YYYY-MM-DD HH:mm" would reject ISO (KIN-2181).
export const parseAppointmentStartTime = (value) => {
  if (!value) return null;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed : null;
};

export const formatConsultationTypeLabel = (type) => {
  if (!type) return "";
  return type
    .toLowerCase()
    .split("_")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const getConsultationTypeCategory = (type) => {
  if (type === "VIDEO") return "video";
  if (type === "PHONE") return "phone";
  return "inPerson";
};

export const formatStaffName = (staff) => {
  if (!staff) return "-";
  const full = `${staff.firstName ?? ""} ${staff.lastName ?? ""}`.trim();
  return full || "-";
};

export const formatAppointmentStatus = (status) => {
  if (!status) return "";
  return status
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

// Mirrors ConsultationBox's parseAdditionalData — appointments can carry
// arbitrary extra fields (e.g. from online booking forms) as a JSON blob.
export const parseAppointmentAdditionalData = (additionalData) => {
  if (!additionalData) return null;

  try {
    const data =
      typeof additionalData === "string"
        ? JSON.parse(additionalData)
        : additionalData;

    if (!data || typeof data !== "object" || Object.keys(data).length === 0) {
      return null;
    }

    return data;
  } catch {
    return null;
  }
};

export const formatAdditionalDataKey = (key) =>
  key
    .replace(/([A-Z])/g, " $1")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase())
    .trim();
